import { defineAsyncComponent } from 'vue'
export default {
  "public-layout": defineAsyncComponent(() => import("/app/app/layouts/PublicLayout.vue").then(m => m.default || m))
}